export default __webpack_public_path__ + "static/media/logo.43a7b926.png";